// extracted by mini-css-extract-plugin
export var videoPlayer = "FullVideoPlayer-module--videoPlayer--82af9";
export var videoPlayer__video = "FullVideoPlayer-module--videoPlayer__video--5d96a";